import Marquee from 'react-fast-marquee'
import Link from 'next/link'
import { usePrefersReducedMotion } from 'lib/hooks/usePrefersReducedMotion'

export const CollectionMarquee = ({ title, subtitle, collection }) => {
  const reducedMotion = usePrefersReducedMotion()
  return (
    <div className="py-32">
      <Marquee speed={reducedMotion ? 0 : 25} autoFill>
        <div className="pb-14">
          <Link
            scroll={false}
            href={`/collections/${collection.slug}`}
            className="mx-[15px] rounded-12 bg-white px-[30px] py-20 text-20 leading-100 text-midGray shadow-md md:text-[26px]"
          >
            {title}{' '}
            {subtitle ? (
              <span>
                <span className="px-8">/</span> {subtitle}
              </span>
            ) : null}
          </Link>
        </div>
      </Marquee>
    </div>
  )
}
